/**
 * Xeito's canonical list of supported locale codes.
 *
 * Moved here (B-new-1289) out of `prompt-security.ts`, which is where it
 * used to live purely because that module happened to need locale-aware
 * refusal strings — nobody looking for "the locale list" thought to check a
 * prompt-injection-defense file, which is exactly how it ended up
 * re-declared independently in `apps/web/src/utils/resolve-locale.ts` and,
 * separately, inlined as raw literals across ~10 other `apps/web` files
 * (tracked as follow-up debt, out of scope for this consolidation — see the
 * B-new-1289 roadmap row).
 *
 * `prompt-security.ts` re-exports these from here so no existing import
 * breaks.
 */

export const SUPPORTED_LOCALES = [
  'en', 'es', 'de', 'fr', 'gl', 'it', 'nl', 'pt',
] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
